exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background-color:#151515;margin:0 auto;padding:0 20px;max-width:1024px;padding-left:calc(100vw - 100%)}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#d3d3d3;margin-top:60px}h1,h2{font-weight:400;text-align:center}li{text-align:left}a{color:#42b983}.filterList,.objectList{background-color:#222;border-radius:5px;padding:10px;margin:10px 0;box-sizing:border-box;display:flex;flex-wrap:wrap}.objectList{width:100%}.objectView .imgContainer{width:128px;height:128px}.filterList>.filter,.objectList>.object{min-width:200px;width:33.3333%}@media only screen and (max-width:768px){.filterList>.filter,.objectList>.object{min-width:150px;width:50%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c474c0ce","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 31
// module chunks = 0